import { render, staticRenderFns } from "./hrzxt.vue?vue&type=template&id=8ea2016c"
import script from "./hrzxt.vue?vue&type=script&lang=js"
export * from "./hrzxt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports